import * as React from 'react';
import {
  List, Datagrid, Edit, Create, Show, SimpleShowLayout,
  TextField, DateField,
  SimpleForm, TextInput, NumberInput,
  TopToolbar, Button, EditButton, ShowButton, required,
  SelectInput
} from 'react-admin';
import { useRedirect } from 'react-admin';
import ArrowBack from '@material-ui/icons/ArrowBack';

const useTxtData = {
  page: { tableName: '积分日志' },
  table: {
    id: 'ID',
    UserId: '用户ID',
    Type: '类型',
    Jifen: '积分',
    Remark: '备注',
    AtTime: '时间'
  }
};

const RowAction = (props) => {
  return (
    <div style={{ textAlign: 'right' }}>
      {/* <EditButton {...props} /><br /> */}
      {/* <ShowButton {...props} /> */}
    </div>
  );
};

export const LFJiFenLogList = (props) => (
  <List {...props} title={useTxtData.page.tableName + '列表'} sort={{ field: 'id', order: 'DESC' }} exporter={false}>
    <Datagrid>
      <TextField label={useTxtData.table.id} source="id" />
      <TextField label={useTxtData.table.UserId} source="UserId" />
      <TextField label={useTxtData.table.Type} source="Type" />
      <TextField label={useTxtData.table.Jifen} source="Jifen" />
      <TextField label={useTxtData.table.Remark} source="Remark" />
      <DateField label={useTxtData.table.AtTime} source="AtTime" showTime />
      <RowAction />
    </Datagrid>
  </List>
);

export const LFJiFenLogShow = (props) => {
  const redirect = useRedirect();
  return (
    <Show title={'查看' + useTxtData.page.tableName} {...props} actions={
      <TopToolbar>
        <Button label="返回列表" onClick={() => redirect('/Admin/LFJiFenLog')} variant="text">
          <ArrowBack />
        </Button>
      </TopToolbar>
    }>
      <SimpleShowLayout>
        <TextField label={useTxtData.table.id} source="id" />
        <TextField label={useTxtData.table.UserId} source="UserId" />
        <TextField label={useTxtData.table.Type} source="Type" />
        <TextField label={useTxtData.table.Jifen} source="Jifen" />
        <TextField label={useTxtData.table.Remark} source="Remark" />
        <DateField label={useTxtData.table.AtTime} source="AtTime" />
      </SimpleShowLayout>
    </Show>
  );
};

export const LFJiFenLogEdit = (props) => (
  <Edit title={'编辑' + useTxtData.page.tableName} {...props}>
    <SimpleForm>
      <NumberInput label={useTxtData.table.UserId} source="UserId" />
      <TextInput label={useTxtData.table.Type} source="Type" />
      <NumberInput label={useTxtData.table.Jifen} source="Jifen" />
      <TextInput label={useTxtData.table.Remark} source="Remark" />
    </SimpleForm>
  </Edit>
);

export const LFJiFenLogCreate = (props) => (
  <Create title={'新增' + useTxtData.page.tableName} {...props}>
    <SimpleForm>
      {/* <NumberInput label={useTxtData.table.UserId} source="UserId" defaultValue={0} /> */}
      <TextInput label={'用户手机号'} source="Mobile" validate={required()} />

      <SelectInput label={useTxtData.table.Type} source="Type" validate={required()}
        choices={[
          { id: '协商议事', name: '协商议事' },
          { id: '卫生打扫', name: '卫生打扫' },
          { id: '志愿服务', name: '志愿服务' },
          { id: '耕地撂荒', name: '耕地撂荒' },
          { id: '乱搭乱建', name: '乱搭乱建' },
          { id: '破坏公共设施', name: '破坏公共设施' },
          { id: '不圈养家禽', name: '不圈养家禽' },
          { id: '焚烧秸秆', name: '焚烧秸秆' },
          { id: '邻里矛盾', name: '邻里矛盾' },
          { id: '其他', name: '其他' },
        ]}
      />

      <NumberInput label={useTxtData.table.Jifen} source="Jifen" defaultValue={0} validate={required()} />
      <TextInput fullWidth label={useTxtData.table.Remark} source="Remark" validate={required()} />
      <div style={{ width: '100%' }}>
        积分计算规则<br />
        （1）加分项<br />
        1. “两废”投放：每投放1公斤物品，获得20积分，积分按实际投放重量精准计算；<br />
        2. 参与村上协商议事：一次获得50积分；<br />
        3. 公共区域环境卫生打扫：一次获得50积分；<br />
        4. 投身镇村志愿服务：一次获得50积分；<br />
        （2）扣分项<br />
        1. 耕地要满栽满种，不撂荒，发现一处撂荒地扣除20积分；<br />
        2. 建房事前要审批，不乱搭乱建，发现一次扣除20积分；<br />
        3. 公共设施齐爱护，发现破坏公共设施一次扣除20积分；<br />
        4. 鸡鸭、猪牛等家禽家畜，圈养不乱放，发现一次扣除20积分；<br />
        5. 爱护生态环境，不露天焚烧秸秆、不乱扔垃圾，发现一次扣除20积分；<br />
        6. 邻里之间要和谐相处，与邻里发生矛盾的，发现一次扣除20积分；<br />
      </div>
    </SimpleForm>
  </Create>
);